<template>
    <div class="g-editor">
        <div :id="id"></div>
    </div>
</template>
<script>
import Editor from "wangeditor";
export default {
    name: 'GEditor',
    data() {
        return {
            editor: null,  //初始化编辑器实例
            // info: ''
            change: false, //标志判断，光标焦点聚焦
        }
    },
    props: {
        //文本框内容
        value: {
            type: String,
            default: ''
        },
        //禁用标识
        disabled: {
            type: Boolean,
            default: false
        },
        //占位符
        placeholder: {
            type: String,
            default: ''
        },
        //必填标识
        requireOnblur: {
            type: Boolean,
            default: false
        },
        //组件唯一标识id
        id: {
            type: String,
            required: true
        },
        width: {
            type: String
        },
        height: {
            type: String
        },
        //图片编码64位
        uploadImgShowBase64: {
            type: Boolean,
            default: true
        },
        showLinkImg: {
            type: Boolean,
            default: false
        },
        //默认菜单配置
        menus: {
            type: Array,
            default() {
                return [
                    'bold', // 粗体
                    // 'italic',//斜体
                    // 'underline',//下划线
                    // 'fontSize',  // 字号
                    // 'strikeThrough',//删除线
                    // 'image', // 插入图片
                    // 'fontName',  // 字体
                    'italic',  // 斜体
                    'underline',  // 下划线
                    'strikeThrough',  // 删除线
                    'foreColor',  // 文字颜色
                    'backColor',  // 背景颜色
                    'link',  // 插入链接
                    'list',  // 列表
                    'justify',  // 对齐方式
                    'quote',  // 引用
                    // 'emoticon',  // 表情
                    'table',  // 表格
                    // 'video',  // 插入视频
                    // 'code',  // 插入代码
                    // 'undo',  // 撤销
                    // 'redo',  // 重复
                ];
            },
        },


    },
    watch: {
        //监听内容变化
        value(newValue, oldValue) {
            if (!oldValue) { //初始化页面框内数据渲染
                this.value = newValue
                window[this.id].txt.html(newValue); //将内容填充框内
                this.$emit('update:value', newValue) // 将内容同步到父组件中
                window[this.id].selection.moveCursor(window[this.id].$textElem.elems[0], true); //防止光标乱跳
            }
            if (newValue == ' ' && oldValue) { //特殊情况：初始化->清空内容->onblur必填校验
                this.change = true
            }
        },
    },
    methods: {
        findEditorParentNode(el) {
            while (el && !el.classList.contains("el-form-item")) {
                el = el.parentNode;
            }
            return el;
        },
        checkEditor(html, id) { //必填校验样式
            var dom = document.getElementById(id);
            const parent = this.findEditorParentNode(dom);
            (!html.replace(/^\s*/g, ""))
                ? (parent.classList.add("is-error"))
                : parent.classList.remove("is-error");
            // !this.value && (this.value =  ' ');
        },
        init() {
            var editor = this.id;
            window[editor] = new Editor('#' + this.id)
            Object.assign(window[editor].config, {
                pasteFilterStyle: false,
                menus: this.menus,
                uploadImgShowBase64: this.uploadImgShowBase64,   // 使用 base64 保存图片
                showLinkImg: this.showLinkImg,
                placeholder: this.placeholder,
                focus: false,
             
                onchange: (html) => {
                    // this.info = html // 绑定当前逐渐地值
                    html= html.replace(/&nbsp;/g, "&#160;");
                    this.$emit('update:value', html) // 将内容同步到父组件中
                    this.$emit('change',html ) //增加父组件changes事件
                },
                onblur: (html) => {
                    this.change && this.requireOnblur && this.checkEditor(html, this.id)
                    this.change = false
                },
                onfocus: (html) => {
                    this.change = true
                },
                pasteTextHandle: (content) => {
                    console.log(content,'yuanlai');
                    // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回e
                    if (content == '' && !content) return ''
                    var str = content
                    // str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
                    // str = str.replace(/<style>[\s\S]*?<\/style>/ig, '')
                    // str = str.replace(/<p\/?[^>]*>/g, '')
                    str = str.replace(/<table\/?[^>]*>/g, "<table border='1' width='100%'' cellpadding='0' cellspacing='0'>")
                    str = str.replace(/<th\/?[^>]*>/g, "<th>")
                    str = str.replace(/<td\/?[^>]*>/g, "<td>")
                    str = str.replace(/<tr\/?[^>]*>/g, "<tr>")
                    //只保留table标签的样式
                    // str = str.replace(/<h2\/?[^>]*>/g, "<p style='font-size:12pt'>")
                    // str = str.replace(/<\/h2\/?[^>]*>/g, "<p style='font-size:12pt'>")
                    str =  str.replace(/<h\d>/gi, "<p style='font-size:12pt'>");
                    str = str.replace(/<\/h\d>/gi, "</p>")
                    // str = str.replace(/<\/(?!\/?table|\/?th|\/?tr|\/?td|\/?span|\/?font)[^<>]*>/ig, '</p>')
                    // str = str.replace(/<(?!table|th|tr|td|span|font|\/p)[^<>]*>/ig, "<p style='font-size:12pt'>")
                    //其余转为没有属性的p标签
                    //   str = str.replace(/[ | ]*\n/g,"<p style='font-size:12pt'>")s
                    // str = str.replace(/<p\/?[^>]*>/g, "<p style='font-size:12pt'>")
                    str = str.replace(/&nbsp;/ig, '')
                    console.log('****', content)
                    console.log('2222', str)
                    return str
                }

            });
//             //配置 自定义处理粘贴的文本内容
// config.pasteTextHandle = function (pasteStr) {
// 	var newStr = 
// 	return newStr
// };


            // 创建富文本编辑器
            window[editor].create();
            window[editor].txt.html(this.value);
            window[editor].disable();
            !this.disabled && window[editor].enable();
        }
    },

    created() {

    },
    mounted() {
        this.init()
    }
}
</script>
<style lang="scss" scoped>
//  /deep/ .w-e-text table {
//         max-width: 500px !important;
//         overflow-x: auto;
//         border-collapse: collapse !important;
//     }
//     /deep/ .w-e-text table td,
//     /deep/ .w-e-text table th {
//         border-bottom: 1px solid #ccc !important;
//         border-right: 1px solid #ccc !important;
//         height: 30px;
//         min-height: 30px;
//         padding: 3px !important;
//         white-space: normal;
//         word-wrap: break-word;
//         word-break: break-all;
//         max-width: 200px;
//     }
    .w-e-text-container {
        z-index: 100 !important;
    }
    .w-e-toolbar {
        z-index: 101 !important;
    }
    /deep/ .w-e-text-container {
        z-index: 100 !important;
    }
    /deep/ .w-e-toolbar {
        z-index: 101 !important;
    }
    .g-editor{
        position: relative;
        // z-index: 100;
    }
    /deep/ .g-editor{
        position: relative;
        // z-index: 100;
    }
    // /deep/ .w-e-table {
    //     height: 20px !important;
    //     line-height: 20px !important;
    // }
    // .w-e-table {
    //     height: 20px !important;
    //     line-height: 20px !important;
    // }
    
/deep/ .w-e-text-container p{
    font-size: 14px !important;
}
table{margin-top: 0pt!important;width: 95% !important;border: 1px solid #000000;margin-bottom: 6px;}td{border: 1px solid #000000;}b{height: 0px;font-size: 1.0rem!important;}b>span{font-family: normal !important;font-weight: bold!important;}img{max-width: 95%!important;border: 1px solid #ddd;}

</style>


// WEBPACK FOOTER //
// src/components/editor/index.vue